export default {module:'Card/Pane',view:'Element/Section',options:{}}